import { ThreadListItemPrimitive, ThreadListPrimitive } from '@assistant-ui/react';
import { Button, SegmentedControl } from '@mantine/core';
import { IconArchive, IconArchiveOff, IconMessageCirclePlus, IconTrash } from '@tabler/icons-react';
import { useState } from 'react';

import classes from './ThreadList.module.css';
import { ReportIssue } from '#plugin-chat/components/thread-list/ReportIssue.tsx';
import { TooltipIconButton } from '#plugin-chat/components/tooltip-icon-button/TooltipIconButton.tsx';

export function ThreadList() {
  const [showArchived, setShowArchived] = useState(false);

  return (
    <ThreadListPrimitive.Root className={classes.threadList}>
      <div className={classes.threadListHeader}>
        <SegmentedControl
          bg="transparent"
          color="dark.6"
          data={[
            { label: 'My conversations', value: false },
            { label: 'Archive', value: true },
          ]}
          fullWidth
          onChange={setShowArchived}
          value={showArchived}
        />
      </div>
      <div className={classes.threadListItems}>
        <ThreadListPrimitive.Items archived={showArchived}>
          {({ threadListItem: { status } }) => (
            <ThreadListItemPrimitive.Root className={classes.threadListItem}>
              <ThreadListItemPrimitive.Trigger className={classes.threadListItemTrigger}>
                <ThreadListItemPrimitive.Title fallback="Unnamed Conversation" />
              </ThreadListItemPrimitive.Trigger>
              {status === 'regular' ? (
                <ThreadListItemPrimitive.Archive asChild>
                  <TooltipIconButton tooltip="Archive thread" variant="subtle">
                    <IconArchive color="var(--mantine-color-dark-1)" size={16} />
                  </TooltipIconButton>
                </ThreadListItemPrimitive.Archive>
              ) : (
                <>
                  <ThreadListItemPrimitive.Unarchive asChild>
                    <TooltipIconButton tooltip="Unarchive thread" variant="subtle">
                      <IconArchiveOff color="var(--mantine-color-dark-1)" size={16} />
                    </TooltipIconButton>
                  </ThreadListItemPrimitive.Unarchive>
                  <ThreadListItemPrimitive.Delete asChild>
                    <TooltipIconButton tooltip="Delete thread" variant="subtle">
                      <IconTrash color="var(--mantine-color-red-4)" size={16} />
                    </TooltipIconButton>
                  </ThreadListItemPrimitive.Delete>
                </>
              )}
            </ThreadListItemPrimitive.Root>
          )}
        </ThreadListPrimitive.Items>
      </div>
      <div className={classes.reportIssue}>
        <ReportIssue />
      </div>
      <div className={classes.threadListFooter}>
        <ThreadListPrimitive.New asChild>
          <Button leftSection={<IconMessageCirclePlus size={16} />} size="lg" variant="filled">
            New Conversation
          </Button>
        </ThreadListPrimitive.New>
      </div>
    </ThreadListPrimitive.Root>
  );
}
